module.exports = __webpack_public_path__ + "img/9788990878793.786cc856.jpg";